// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1aG4r","footer":"Form_footer__3HVD_"};